export const updateStepInputFrame = (stepId) => {
  if (typeof window === 'undefined') return;
  if (!stepId) return;

  // Find all turbo-frame elements whose ID starts with "input_" and ends with
  // stepId. The actual ID will contain information about the specific model and
  // we do not have that context here.
  const allTurboFrames = document.querySelectorAll('turbo-frame');
  const matchingFrames = Array.from(allTurboFrames).filter(frame => {
    const id = frame.id;
    const src = frame.getAttribute('src');
    return id && id.startsWith('input_') && id.endsWith(stepId) && src;
  });

  if (matchingFrames.length === 0) {
    console.warn(`[updateStepInputFrame] No matching frames found for step ${stepId}`);
    return;
  }

  // Reload all matching frames
  matchingFrames.forEach(frame => {
    if (typeof frame.reload === 'function') {
      frame.reload();
    }
  });
};
